// =============================================================================
// 업로드 허용 확장자 — Figma 코멘트 확정안: 파일 탐색기에서 지정 확장자만 선택
// 가능해야 하고(accept), 우회 경로(드래그앤드롭)는 업로드 불가 토스트로 차단.
// 원천은 서버 검증(packages/main/src/server/routes/media.ts VIDEO_EXT/IMAGE_EXT)
// — 목록 변경 시 양쪽 함께 갱신.
// =============================================================================

const VIDEO_EXTENSIONS = ['mp4', 'mov', 'm4v', 'webm', 'mkv'] as const;
const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp'] as const;

function toAccept(exts: readonly string[]): string {
  return exts.map((e) => `.${e}`).join(',');
}

/** 파일 탐색기 accept — 비디오+이미지 (MIME 와일드카드 금지: 비지원 포맷 선택 방지).
 *  Lottie(json)는 Player 재생 미지원이라 업로드 자체를 차단(서버도 415 거부). */
export const MEDIA_ACCEPT = toAccept([...VIDEO_EXTENSIONS, ...IMAGE_EXTENSIONS]);

/** 드래그앤드롭 등 accept를 우회한 파일의 확장자 사전 검증. */
export function isAllowedMediaFile(name: string): boolean {
  const ext = name.slice(name.lastIndexOf('.') + 1).toLowerCase();
  if (!ext || ext === name.toLowerCase()) return false;
  return (
    (VIDEO_EXTENSIONS as readonly string[]).includes(ext) ||
    (IMAGE_EXTENSIONS as readonly string[]).includes(ext)
  );
}
